import React from "react";
import IndexedFormRow from "../IndexedFormRow";
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import { Field } from "redux-form";
import { renderField } from "../../../utils/formUtils";
import PrivacyRow from "../PrivacyRow/PrivacyRow";
import { Translate } from "react-localize-redux";

const defaultEmailAddress = {
  address: "",
  privacy: "PU",
  category: "Home",
  order_index: 0
};

const EmailAddressFormPanel = () => (
  <CollapseContainer title={<Translate id="Email" />} startCollapsed={false}>
    <IndexedFormRow
      defaultEntry={defaultEmailAddress}
      privacyRow={<PrivacyRow rowOffset={10} />}
      modelArrayName="email_addresses"
      dataComponent={member => (
        <Field
          name={`${member}.address`}
          type="text"
          hideLabel={true}
          component={renderField}
          label="address"
        />
      )}
    />
  </CollapseContainer>
);

export default EmailAddressFormPanel;



// WEBPACK FOOTER //
// ./src/components/forms/EmailAddressFormPanel/EmailAddressFormPanel.jsx